var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "compliance-reporting-settings-single-button-wrapper" },
    [
      _c(
        "button",
        {
          staticClass: "compliance-reporting-settings-single-button",
          style: _vm.buttonStyleObject,
          on: { click: _vm.buttonClicked },
        },
        [_vm._v(" " + _vm._s(_vm.displayValue) + " ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }